import { protectedResources } from "../../authConfig";
import { unregisteredUser } from "../../utils/errorHandler";
import axios from "axios";
import { getAuth } from "../api/auth";
import { msalInstance } from "../../index";
import { setupCache } from 'axios-cache-adapter';
import localforage from 'localforage';
import ApiStateManager from "../../utils/apiStateManager";

const stateManager = ApiStateManager.getInstance();

const forageStore = localforage.createInstance({
  driver: [localforage.INDEXEDDB, localforage.LOCALSTORAGE],
  name: 'api-cache',
});

const cache = setupCache({
  maxAge: 1440 * 60 * 1000, // 1 Day = 1440 minutes
  exclude: {
    query: false,
    methods: ['put', 'patch', 'delete']
  },
  store: forageStore,
  invalidate: async (config, request) => {
    if (request.clearCacheEntry) {
      await config.store.removeItem(config.uuid)
    }
  }
})

const axiosMapInstance = axios.create({
  adapter: cache.adapter
});

axiosMapInstance.interceptors.request.use(
  async (config) => {
    // set request inprogress
    const { hideLoader = false } = config;
    if (!hideLoader) stateManager.setRequestCount(1);

    const activeAccount = msalInstance.getActiveAccount();
    const accounts = msalInstance.getAllAccounts();
    if (!activeAccount && accounts.length === 0) {
      throw new Error("No active account");
    }
    let tokenCheck = localStorage.getItem("token");
    if (!tokenCheck) {
      const authResponse = await msalInstance.acquireTokenSilent({
        scopes: protectedResources.authAPI.scopes,
        account: activeAccount || accounts[0],
      });
      localStorage.setItem("token", authResponse.accessToken);
      tokenCheck = authResponse.accessToken;
    }
    const user = JSON.parse(localStorage.getItem("user"));
    if (!user && tokenCheck) {
      const authNew = await getAuth(tokenCheck);
      localStorage.setItem("user", JSON.stringify(authNew));
      if (!authNew.is_active) throw unregisteredUser(authNew.name);
      config.headers = {
        Authorization: `Bearer ${tokenCheck}`,
      };
      return config;
    }
    if (!user.is_active) throw unregisteredUser(user.name);
    config.headers = {
      Authorization: `Bearer ${tokenCheck}`,
    };
    return config;
  },
  function (error) {
    // Do something with request error

    // set request inprogress
    const { hideLoader = false } = error.config;
    if (!hideLoader) stateManager.setRequestCount(-1);

    return Promise.reject(error);
  }
);

axiosMapInstance.interceptors.response.use(
  (response) => {
    // set request inprogress
    const { hideLoader = false } = response.config;
    if (!hideLoader) stateManager.setRequestCount(-1);

    return response;
  },
  async function (error) {
    const originalRequest = error.config;
    if (error?.response?.status === 401) {
      msalInstance.logoutRedirect();
      localStorage.removeItem("user");
      localStorage.removeItem("token");
      localStorage.removeItem("superset_access_token");
    }
    if ((error?.response?.status === 502 || !error.response || !error.response.status) &&
      originalRequest && !originalRequest._retry) {
      originalRequest._retry = true;
      originalRequest.headers['check-response-size'] = true;
      stateManager.setRequestCount(-1);
      return axios(originalRequest);
    }
    // set request inprogress
    stateManager.setRequestCount(-1);
    return Promise.reject(error);
  }
);

export default axiosMapInstance;
